export const INSIGHTS_VISIBILITY = {
  VISIBLE_TO_ALL: 'VisibleToAll',
  ADMINS_ONLY: 'AdminsOnly',
  NOT_VISIBLE: 'NotVisible'
};
